import * as React from 'react';
import { DashboardMenuItem, Menu, MenuItemLink, usePermissions } from 'react-admin';

import {
  Domain,
  PeopleAlt,
  DoorFront,
  TagSharp,
  Category,
  CategoryOutlined,
  JoinFull,
  DashboardCustomize,
  BackupTable,
  Receipt,
  BurstMode,
  Image,
  Article,
  Widgets,
  CreditCard,
  ConfirmationNumber,
  Newspaper,
  PointOfSale,
  PersonPin,
  ListAlt,
  PeopleOutline,
  EmojiPeople,
  Add,
  Event,
  EventRepeat,
  CalendarMonth,
  ViewDashboard,
  NotificationsActive,
  SystemUpdateAlt,
  Code,
  Calculate,
  Campaign,
  Translate,
} from '@mui/icons-material';
import { useTranslate } from 'react-admin';
import { FileTableBoxMultiple } from 'mdi-material-ui';
import pkg from '../../../package.json';
import customRoutes from '../../app/routes';
import UpcomingEventsMenuLink from './UpcomingEventsMenuLink';
import RefundRequestsMenuLink from './RefundRequestsMenuLink';
import ApplicationPendingMenuLink from './ApplicationPendingMenuLink';
const VERSION = `v${pkg.version}`;

const CustomMenu = (props) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  if (!permissions) return null;

  switch (permissions.crole) {
    case 'venueManager':
      return (
        <Menu {...props}>
          <div style={{ background: 'rgb(156,39,176)', marginTop: -10, textAlign: 'center' }}>
            <h3 style={{ color: 'white' }}>Venue Manager</h3>
            <h4 style={{ color: 'white' }}>{permissions.email}</h4>
            <h6 style={{ color: '#EEE', margin: 0, padding: 0, marginTop: -20, marginBottom: 10 }}>
              {VERSION}
            </h6>
          </div>
          {/* <h5 style={{ marginLeft: 10, borderBottom: '1px solid #EEE', fontWeight: 300, paddingBottom: 5, marginBottom: 5 }}>Sales</h5>
                    <MenuItemLink to="/sales-old" primaryText="Sales" leftIcon={<Receipt />} style={{ fontSize: 12.5 }} />
                    <MenuItemLink to="/tickets-old" primaryText="Tickets" leftIcon={<ConfirmationNumber />} style={{ fontSize: 12.5 }} /> */}

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.events_v2', 'Events')}
          </h5>
          <MenuItemLink
            to="/events-v2/create"
            primaryText={translate('menu.new_event', 'New Event')}
            leftIcon={<Add />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/events-v2"
            primaryText={translate('menu.upcoming_events', 'Upcoming Events')}
            leftIcon={<CalendarMonth />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/past-events"
            primaryText={translate('menu.past_events', 'Past Events')}
            leftIcon={<EventRepeat />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.venues', 'Venue')}
          </h5>
          <MenuItemLink
            to="/venues"
            primaryText={translate('ra.action.edit', 'Edit')}
            leftIcon={<DoorFront />}
            style={{ fontSize: 12.5 }}
          />
        </Menu>
      );
    case 'organisationCompanyManager':
      return (
        <Menu {...props}>
          <div style={{ background: 'rgb(156,39,176)', marginTop: -10, textAlign: 'center' }}>
            <h3 style={{ color: 'white' }}>Company Manager</h3>
            <h4 style={{ color: 'white' }}>{permissions.email}</h4>
            <h6 style={{ color: '#EEE', margin: 0, padding: 0, marginTop: -20, marginBottom: 10 }}>
              {VERSION}
            </h6>
          </div>
          {/* <h5 style={{ marginLeft: 10, borderBottom: '1px solid #EEE', fontWeight: 300, paddingBottom: 5, marginBottom: 5 }}>Sales</h5>
                    <MenuItemLink to="/sales-old" primaryText="Sales" leftIcon={<Receipt />} style={{ fontSize: 12.5 }} />
                    <MenuItemLink to="/tickets-old" primaryText="Tickets" leftIcon={<ConfirmationNumber />} style={{ fontSize: 12.5 }} /> */}

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.events_v2', 'Events')}
          </h5>
          <MenuItemLink
            to="/events-v2/create"
            primaryText={translate('menu.new_event', 'New Event')}
            leftIcon={<Add />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/events-v2"
            primaryText={translate('menu.upcoming_events', 'Upcoming Events')}
            leftIcon={<CalendarMonth />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/past-events"
            primaryText={translate('menu.past_events', 'Past Events')}
            leftIcon={<EventRepeat />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.org_companies', 'Company')}
          </h5>
          <MenuItemLink
            to="/organisationCompanies"
            primaryText={translate('ra.action.edit', 'Edit')}
            leftIcon={<JoinFull />}
            style={{ fontSize: 12.5 }}
          />
        </Menu>
      );
    case 'affiliate':
      return (
        <Menu {...props}>
          <div style={{ background: 'rgb(156,39,176)', marginTop: -10, textAlign: 'center' }}>
            <h3 style={{ color: 'white' }}>Affiliate</h3>
            <h4 style={{ color: 'white' }}>{permissions.email}</h4>
            <h6 style={{ color: '#EEE', margin: 0, padding: 0, marginTop: -20, marginBottom: 10 }}>
              {VERSION}
            </h6>
          </div>
          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.sales', 'Sales')}
          </h5>
          {/* <MenuItemLink to="/sales-old" primaryText="Sales" leftIcon={<Receipt />} style={{ fontSize: 12.5 }} /> */}
        </Menu>
      );
    case 'operator':
      return (
        <Menu {...props}>
          <div style={{ background: 'rgb(156,39,176)', marginTop: -10, textAlign: 'center' }}>
            <h3 style={{ color: 'white' }}>Operator</h3>
            <h5 style={{ color: 'white' }}>{permissions.email}</h5>
            <h6 style={{ color: '#EEE', margin: 0, padding: 0, marginTop: -20, marginBottom: 10 }}>
              {VERSION}
            </h6>
          </div>

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.events_v2', 'Events')}
          </h5>
          <MenuItemLink
            to="/events-v2/create"
            primaryText={translate('menu.new_event', 'New Event')}
            leftIcon={<Add />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/events-v2"
            primaryText={translate('menu.upcoming_events', 'Upcoming Events')}
            leftIcon={<CalendarMonth />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/past-events"
            primaryText={translate('menu.past_events', 'Past Events')}
            leftIcon={<EventRepeat />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/groupEvents?filter=%7B%7D"
            primaryText={translate('menu.group_events', 'Group Events')}
            leftIcon={<BurstMode />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.notifications', 'Notifications')}
          </h5>
          <MenuItemLink
            to={customRoutes.PUSH_NOTIFICATIONS}
            primaryText={translate('menu.notifications', 'Bildirimler')}
            leftIcon={<NotificationsActive />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.people', 'People')}
          </h5>
          <MenuItemLink
            to="/users?filter=%7B%7D"
            primaryText={translate('menu.users', 'Users')}
            leftIcon={<PeopleAlt />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/affiliates?filter=%7B%7D"
            primaryText={translate('menu.affiliates', 'Affiliates')}
            leftIcon={<PersonPin />}
            style={{ fontSize: 12.5 }}
          />
          <ApplicationPendingMenuLink
            companyType="salesAgent"
            to="/saleAgents?filter=%7B%7D"
            primaryText={translate('menu.sale_agents', 'Sale Agents')}
            icon={PeopleOutline}
          />
          <MenuItemLink
            to="/promoters?filter=%7B%7D"
            primaryText={translate('menu.promoters', 'Promoters')}
            leftIcon={<EmojiPeople />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/affiliateForm?filter=%7B%7D"
            primaryText={translate('menu.affiliate_form', 'Affiliate Form')}
            leftIcon={<PersonPin />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/deleteUserRequests"
            primaryText={translate('menu.delete_requests', 'Delete Requests')}
            leftIcon={<PeopleOutline />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.places', 'Places')}
          </h5>
          <ApplicationPendingMenuLink
            companyType="venue"
            to="/venues?filter=%7B%7D"
            primaryText={translate('menu.venues', 'Venues')}
            icon={DoorFront}
          />
          <MenuItemLink
            to="/layouts?filter=%7B%7D"
            primaryText={translate('menu.layouts', 'Layouts')}
            leftIcon={<Article />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/layouts-v2"
            primaryText={translate('menu.layouts_v2', 'Layouts v2')}
            leftIcon={<Article />}
            style={{ fontSize: 12.5 }}
          />

          <ApplicationPendingMenuLink
            companyType="organisationCompany"
            to="/organisationCompanies?filter=%7B%7D"
            primaryText={translate('menu.org_companies', 'Org. Companies')}
            icon={JoinFull}
          />
          <MenuItemLink
            to="/salePoints?filter=%7B%7D"
            primaryText={translate('menu.sale_points', 'Sale Points')}
            leftIcon={<PointOfSale />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.definitions', 'Definitions')}
          </h5>
          <MenuItemLink
            to="/featureds"
            primaryText={translate('menu.featured', 'Featured')}
            leftIcon={<FileTableBoxMultiple />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/categories"
            primaryText={translate('menu.categories', 'Categories')}
            leftIcon={<Category />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/subcategories"
            primaryText={translate('menu.subcategories', 'Sub Categories')}
            leftIcon={<CategoryOutlined />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/venueCategories"
            primaryText={translate('menu.venue_categories', 'Venue Categories')}
            leftIcon={<BackupTable />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/cities"
            primaryText={translate('menu.cities', 'Cities')}
            leftIcon={<Domain />}
            style={{ fontSize: 12.5 }}
          />
          {/* <MenuItemLink to="/eventTags" primaryText="Event Tags" leftIcon={<TagSharp />} style={{ fontSize: 12.5 }} /> */}

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.website', 'Website')}
          </h5>
          <MenuItemLink
            to="/homeSections"
            primaryText={translate('menu.home_sections', 'Home Sections')}
            leftIcon={<Widgets />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/heros/home"
            primaryText={translate('menu.hero_banner', 'Home Special Event Hero')}
            leftIcon={<DashboardCustomize />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/pages"
            primaryText={translate('menu.pages', 'Pages')}
            leftIcon={<Article />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/news"
            primaryText={translate('menu.news', 'News')}
            leftIcon={<Newspaper />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/scripts"
            primaryText={translate('menu.scripts', 'Scripts')}
            leftIcon={<Code />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.accountancy', 'Accountancy')}
          </h5>
          <MenuItemLink
            to="/settlementCategories"
            primaryText={translate('menu.accountancy_items', 'Accountancy Items')}
            leftIcon={<Calculate />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.advertising', { _: 'Advertising' })}
          </h5>
          <MenuItemLink
            to="/adPackages"
            primaryText={translate('menu.ad_packages', { _: 'Ad Packages' })}
            leftIcon={<Campaign />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/adApplications"
            primaryText={translate('menu.ad_applications', { _: 'Ad Applications' })}
            leftIcon={<ListAlt />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.mobile_app', 'Mobil Uygulama')}
          </h5>
          <MenuItemLink
            to="/appVersionConfigs"
            primaryText={translate('menu.app_version', 'Sürüm Kontrolü')}
            leftIcon={<SystemUpdateAlt />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.super_admin', 'Super Admin')}
          </h5>
          <MenuItemLink
            to="/events?filter=%7B%7D"
            primaryText={translate('menu.v1_archive', 'Event V1 Archive')}
            leftIcon={<Image />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/sessionEvents?filter=%7B%7D"
            primaryText="Session Events Archive"
            leftIcon={<Image />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/systemParameters/system"
            primaryText={translate('menu.parameters', 'Parameters')}
            leftIcon={<FileTableBoxMultiple />}
            style={{ fontSize: 12.5 }}
          />
          {/* <MenuItemLink to="/eventLogs" primaryText="Event Logs" leftIcon={<ListAlt />} style={{ fontSize: 12.5 }} /> */}
          {/* <MenuItemLink to="/verificationLogs" primaryText="V. Logs" leftIcon={<ListAlt />} style={{ fontSize: 12.5 }} /> */}
          {/* <MenuItemLink to="/paymentLogs" primaryText="Sale Logs" leftIcon={<ListAlt />} style={{ fontSize: 12.5 }} /> */}
        </Menu>
      );
    case 'editor':
      return (
        <Menu {...props}>
          <div style={{ background: 'rgb(156,39,176)', marginTop: -10, textAlign: 'center' }}>
            <h3 style={{ color: 'white' }}>Editor</h3>
            <h5 style={{ color: 'white' }}>{permissions.email}</h5>
            <h6 style={{ color: '#EEE', margin: 0, padding: 0, marginTop: -20, marginBottom: 10 }}>
              {VERSION}
            </h6>
          </div>
          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.content', { _: 'Content' })}
          </h5>
          <MenuItemLink
            to="/news"
            primaryText={translate('menu.news', { _: 'News' })}
            leftIcon={<Newspaper />}
            style={{ fontSize: 12.5 }}
          />
        </Menu>
      );
    case 'admin':
      return (
        <Menu {...props}>
          <div style={{ background: 'rgb(156,39,176)', marginTop: -10, textAlign: 'center' }}>
            <h3 style={{ color: 'white' }}>Admin</h3>
            <h5 style={{ color: 'white' }}>{permissions.email}</h5>
            <h6 style={{ color: '#EEE', margin: 0, padding: 0, marginTop: -20, marginBottom: 10 }}>
              {VERSION}
            </h6>
          </div>

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.dashboard', 'Dashboard')}
          </h5>
          <MenuItemLink
            to="/dashboard"
            primaryText={translate('menu.dashboard', 'Dashboard')}
            leftIcon={<FileTableBoxMultiple />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.events_v2', 'Events (v2)')}
          </h5>
          <MenuItemLink
            to="/events-v2/create"
            primaryText={translate('menu.new_event', 'New Event')}
            leftIcon={<Add />}
            style={{ fontSize: 12.5 }}
          />
          <UpcomingEventsMenuLink />
          <MenuItemLink
            to="/past-events"
            primaryText={translate('menu.past_events', 'Past Events')}
            leftIcon={<EventRepeat />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/groupEvents?filter=%7B%7D"
            primaryText={translate('menu.group_events', 'Group Events')}
            leftIcon={<BurstMode />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.notifications', 'Notifications')}
          </h5>
          <MenuItemLink
            to={customRoutes.PUSH_NOTIFICATIONS}
            primaryText={translate('menu.notifications', 'Bildirimler')}
            leftIcon={<NotificationsActive />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.sales', 'Sales')}
          </h5>
          <MenuItemLink
            to="/sales?last=100"
            primaryText={translate('menu.sales', 'Sales')}
            leftIcon={<Receipt />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/tickets"
            primaryText={translate('menu.tickets', 'Tickets')}
            leftIcon={<ConfirmationNumber />}
            style={{ fontSize: 12.5 }}
          />
          <RefundRequestsMenuLink />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.people', 'People')}
          </h5>
          <MenuItemLink
            to="/users?filter=%7B%7D"
            primaryText={translate('menu.users', 'Users')}
            leftIcon={<PeopleAlt />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/affiliates?filter=%7B%7D"
            primaryText={translate('menu.affiliates', 'Affiliates')}
            leftIcon={<PersonPin />}
            style={{ fontSize: 12.5 }}
          />
          <ApplicationPendingMenuLink
            companyType="salesAgent"
            to="/saleAgents?filter=%7B%7D"
            primaryText={translate('menu.sale_agents', 'Sale Agents')}
            icon={PeopleOutline}
          />
          <MenuItemLink
            to="/promoters?filter=%7B%7D"
            primaryText={translate('menu.promoters', 'Promoters')}
            leftIcon={<EmojiPeople />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/affiliateForm?filter=%7B%7D"
            primaryText={translate('menu.affiliate_form', 'Affiliate Form')}
            leftIcon={<PersonPin />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/deleteUserRequests"
            primaryText={translate('menu.delete_requests', 'Delete Requests')}
            leftIcon={<PeopleOutline />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.places', 'Places')}
          </h5>
          <ApplicationPendingMenuLink
            companyType="venue"
            to="/venues?filter=%7B%7D"
            primaryText={translate('menu.venues', 'Venues')}
            icon={DoorFront}
          />
          <MenuItemLink
            to="/layouts?filter=%7B%7D"
            primaryText={translate('menu.layouts', 'Layouts')}
            leftIcon={<Article />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/layouts-v2"
            primaryText={translate('menu.layouts_v2', 'Layouts v2')}
            leftIcon={<Article />}
            style={{ fontSize: 12.5 }}
          />

          <ApplicationPendingMenuLink
            companyType="organisationCompany"
            to="/organisationCompanies?filter=%7B%7D"
            primaryText={translate('menu.org_companies', 'Org. Companies')}
            icon={JoinFull}
          />
          <MenuItemLink
            to="/salePoints?filter=%7B%7D"
            primaryText={translate('menu.sale_points', 'Sale Points')}
            leftIcon={<PointOfSale />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.definitions', 'Definitions')}
          </h5>
          <MenuItemLink
            to="/featureds"
            primaryText={translate('menu.featured', 'Featured')}
            leftIcon={<FileTableBoxMultiple />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/categories"
            primaryText={translate('menu.categories', 'Categories')}
            leftIcon={<Category />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/subcategories"
            primaryText={translate('menu.subcategories', 'Sub Categories')}
            leftIcon={<CategoryOutlined />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/venueCategories"
            primaryText={translate('menu.venue_categories', 'Venue Categories')}
            leftIcon={<BackupTable />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/cities"
            primaryText={translate('menu.cities', 'Cities')}
            leftIcon={<Domain />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.website', 'Website')}
          </h5>
          <MenuItemLink
            to="/homeSections"
            primaryText={translate('menu.home_sections', 'Home Sections')}
            leftIcon={<Widgets />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/heros/home"
            primaryText={translate('menu.hero_banner', 'Home Special Event Hero')}
            leftIcon={<DashboardCustomize />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/pages"
            primaryText={translate('menu.pages', 'Pages')}
            leftIcon={<Article />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/news"
            primaryText={translate('menu.news', 'News')}
            leftIcon={<Newspaper />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/scripts"
            primaryText={translate('menu.scripts', 'Scripts')}
            leftIcon={<Code />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.accountancy', 'Accountancy')}
          </h5>
          <MenuItemLink
            to="/settlementCategories"
            primaryText={translate('menu.accountancy_items', 'Accountancy Items')}
            leftIcon={<Calculate />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.advertising', { _: 'Advertising' })}
          </h5>
          <MenuItemLink
            to="/adPackages"
            primaryText={translate('menu.ad_packages', { _: 'Ad Packages' })}
            leftIcon={<Campaign />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/adApplications"
            primaryText={translate('menu.ad_applications', { _: 'Ad Applications' })}
            leftIcon={<ListAlt />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.mobile_app', 'Mobil Uygulama')}
          </h5>
          <MenuItemLink
            to="/appVersionConfigs"
            primaryText={translate('menu.app_version', 'Sürüm Kontrolü')}
            leftIcon={<SystemUpdateAlt />}
            style={{ fontSize: 12.5 }}
          />

          <h5
            style={{
              marginLeft: 10,
              borderBottom: '1px solid #EEE',
              fontWeight: 300,
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            {translate('menu.super_admin', 'Super Admin')}
          </h5>
          <MenuItemLink
            to="/events?filter=%7B%7D"
            primaryText={translate('menu.v1_archive', 'Event V1 Archive')}
            leftIcon={<Image />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/sessionEvents?filter=%7B%7D"
            primaryText="Session Events Archive"
            leftIcon={<Image />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to="/systemParameters/system"
            primaryText={translate('menu.parameters', 'Parameters')}
            leftIcon={<FileTableBoxMultiple />}
            style={{ fontSize: 12.5 }}
          />
          <MenuItemLink
            to={customRoutes.DEEPL_SETTINGS}
            primaryText={translate('menu.deepl_settings', 'DeepL Ayarları')}
            leftIcon={<Translate />}
            style={{ fontSize: 12.5 }}
          />
          {/* <MenuItemLink to="/eventLogs" primaryText="Event Logs" leftIcon={<ListAlt />} style={{ fontSize: 12.5 }} /> */}
          {/* <MenuItemLink to="/verificationLogs" primaryText="V. Logs" leftIcon={<ListAlt />} style={{ fontSize: 12.5 }} /> */}
          {/* <MenuItemLink to="/paymentLogs" primaryText="Sale Logs" leftIcon={<ListAlt />} style={{ fontSize: 12.5 }} /> */}
        </Menu>
      );
    default:
      return null;
  }
};

export default CustomMenu;
